import Components from "../components";
import SearchParser from "../components/fault_search/search_parser";
import * as Turbo from "@hotwired/turbo";
import tippy from "tippy.js";

class SearchBookmark extends Components.Base {
  initialize() {
    this.csrfToken = $("meta[name=csrf-token]").attr("content");

    this.outsideClick = this.outsideClick.bind(this);
    document.addEventListener("click", this.outsideClick);

    this.setup();
  }

  setup() {
    this.currentSearchParams = this.$el.data("current-search-params");
    this.searchPath = this.$el.data("search-path");
    this.$toggleBookmark = this.$el.find(".toggle-bookmark");
    this.$showBookmarks = this.$el.find(".show-bookmarks");
    this.$bookmarks = this.$el.find(".bookmarks");

    this.fragmentizeBookmarks();
    this.$toggleBookmark.on("click", this.onBookmarkToggle.bind(this));
    this.$showBookmarks.on("click", this.onShowBookmarks.bind(this));
    this.$bookmarks.on("click", ".bookmark", this.onBookmarkClick.bind(this));
    this.$bookmarks.on(
      "click",
      ".toggle-default-bookmark",
      this.onToggleDefaultBookmark.bind(this),
    );
    this.$bookmarks.on(
      "click",
      ".delete-bookmark",
      this.onDeleteBookmark.bind(this),
    );

    this.setupTooltip();
  }

  unbind() {
    document.removeEventListener("click", this.outsideClick);
    this.tips.forEach((e) => e.destroy());
  }

  setupTooltip() {
    this.tips = [];
    this.$el
      .find(".toggle-default-bookmark")
      .toArray()
      .forEach((e) => {
        let content = "Pin as default search";
        if ($(e).parents(".bookmark").hasClass("default")) {
          content = "Unpin default search";
        }
        this.tips.push(tippy(e, { content }));
      });
  }

  fragmentizeBookmarks() {
    this.$bookmarks.find(".query:not(.fragmented)").each((i, el) => {
      const $el = $(el);
      const search = $el.html();
      $el.empty();
      SearchParser.parse(search).forEach((fragment) => {
        if (fragment.trim() !== "") {
          $el.append(`<span>${fragment}</span>`);
        }
      });
      $el.addClass("fragmented");
    });
  }

  reloadComponent(request) {
    return request
      .then((res) => res.json())
      .then((body) => {
        if ("error" in body) {
          $(window).trigger("rails:flash", {
            type: "error",
            message: body.error,
          });
        } else {
          const $html = $(body.bookmarks);
          this.transferState($html, () => {
            this.$el.replaceWith($html);
            this.$el = $html;
            this.el = $html[0];
            this.setup();
          });
        }
      });
  }

  // Since we are replacing the html with active state and events, this method
  // allows for capturing state before replacement (like scroll position) and
  // injects saved properties into the replaced element.
  transferState($nextEl, transferFn) {
    if (this.$el.hasClass("bookmarks-open")) {
      $nextEl.addClass("bookmarks-open");
    }
    const scroll = this.$bookmarks.scrollTop();
    transferFn();
    $nextEl.find(".bookmarks").scrollTop(scroll);
  }

  onBookmarkClick(evt) {
    const $bookmark = $(evt.currentTarget);
    const query = $bookmark.data("bookmark-params");
    if (this.searchPath !== "") {
      Turbo.visit(`${this.searchPath}?${$.param(query)}`);
    } else {
      Turbo.visit(`${window.location.pathname}?${$.param(query)}`);
    }
  }

  onDeleteBookmark(evt) {
    const $bookmark = $(evt.currentTarget).parents(".bookmark");
    this.deleteBookmark($bookmark.data("bookmark-id"));
    return false;
  }

  onToggleDefaultBookmark(evt) {
    const $bookmark = $(evt.currentTarget).parents(".bookmark");
    const isDefault = !$bookmark.hasClass("default");
    const bookmarkId = $bookmark.data("bookmark-id");
    this.reloadComponent(
      fetch(`/users/search_bookmarks/${bookmarkId}`, {
        method: "PUT",
        ...this.baseParams({ search_bookmark: { is_default: isDefault } }),
      }),
    );

    return false;
  }

  baseParams(body = {}) {
    return {
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
      },
      body: JSON.stringify({
        current_search_params: this.currentSearchParams,
        search_path: this.searchPath,
        ...body,
      }),
    };
  }

  onBookmarkToggle() {
    if (this.$el.data("search-bookmark-id")) {
      this.deleteBookmark(this.$el.data("search-bookmark-id"));
    } else {
      this.reloadComponent(
        fetch("/users/search_bookmarks", {
          method: "POST",
          ...this.baseParams(),
        }),
      );
    }
  }

  deleteBookmark(id) {
    this.reloadComponent(
      fetch(`/users/search_bookmarks/${id}`, {
        method: "DELETE",
        ...this.baseParams(),
      }),
    );
  }

  onShowBookmarks() {
    this.$el.toggleClass("bookmarks-open");
  }

  outsideClick(evt) {
    if (!this.el.contains(evt.target) && this.$el.hasClass("bookmarks-open")) {
      this.$el.removeClass("bookmarks-open");
    }
  }
}

Components.collection.register({
  selector: ".c-search-bookmark",
  klass: SearchBookmark,
});
